import comp from "./UnitDetails";
export default comp;
